import React from 'react';
const NoScript = ({ children, wrap = true })=>{
    return wrap ? /*#__PURE__*/ React.createElement("noscript", null, children) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
NoScript.displayName = 'NoScript';
export default NoScript;
